<div class="discussion-create">
  <app-header></app-header>

  <div class="discussion-create--content">
    <!-- Header Section -->
    <app-asset-header [config]="headerConfig"></app-asset-header>

    <!-- Main Content -->
    <div class="discussion-create--main">
      <div class="discussion-create--container">
        <!-- Discussion Sidebar -->
        <aside class="discussion-create--sidebar">
          <!-- New Discussion Button -->
          <button 
            class="discussion-create--new-discussion-btn"
            type="button"
            (click)="createNewDiscussion()"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            New Discussion
          </button>
          <app-discussion-sidebar [activeTab]="activeTab"></app-discussion-sidebar>
        </aside>

        <!-- Main Content Section -->
        <main class="discussion-create--main-content">
          <div class="discussion-content">
            <div class="discussion-content--header">
              <div class="discussion-content--title-wrapper">
                <div class="discussion-content--title-row">
                  <h2 class="discussion-content--title">{{ editDiscussionId ? 'Edit Discussion' : 'New Discussion' }}</h2>
                </div>
                <p class="discussion-content--description">{{ editDiscussionId ? 'Update your discussion and save changes.' : 'Create a new discussion to ask questions, share ideas, or start a conversation with the community.' }}</p>
              </div>
            </div>
            <div
              class="discussion-create--admin-warning"
              *ngIf="editDiscussionId && adminComment && isEditDiscussionOwner"
              role="status"
            >
              <div class="discussion-create--admin-warning-icon" aria-hidden="true">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 9v4M12 17h.01M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </div>
              <div class="discussion-create--admin-warning-body">
                <strong class="discussion-create--admin-warning-title">Platform Admin Comment</strong>
                <p class="discussion-create--admin-warning-text">{{ adminComment }}</p>
              </div>
            </div>
            <div *ngIf="isLoadingEdit" class="discussion-create--loading">Loading discussion...</div>
            <app-create-discussion-form
              *ngIf="!isLoadingEdit"
              [initialValues]="discussionInitialValues"
              [discussionId]="editDiscussionId ?? undefined"
              [isEditMode]="!!editDiscussionId"
              (publish)="onDiscussionPublish($event)"
              (cancel)="onDiscussionCancel()"
            ></app-create-discussion-form>
          </div>
        </main>
      </div>
    </div>
  </div>

  <app-footer></app-footer>

  <!-- Login Modal -->
  <app-login-modal
    [(visible)]="showLoginModal"
  ></app-login-modal>

  <app-confirmation-dialog
    [(visible)]="showDiscussionSubmittedDialog"
    type="success"
    themeColor="green"
    [title]="discussionSubmittedDialogTitle"
    [message]="discussionSubmittedDialogMessage"
    [showCancelButton]="false"
    confirmLabel="OK"
    (onConfirm)="onDiscussionSubmittedAcknowledge()"
    (onClose)="onDiscussionSubmittedAcknowledge()"
  />
</div>
